import { Facet } from '@/types/filter.types';

const STORAGE_KEY = 'plp_filter_state';

interface PlpFilterState {
  currentPage: number;
  dynamicFacets: Facet[] | undefined;
}

export const savePlpFilterState = (state: PlpFilterState): void => {
  try {
    sessionStorage.setItem(STORAGE_KEY, JSON.stringify(state));
  } catch {
    // silently ignore storage errors
  }
};

export const loadPlpFilterState = (): PlpFilterState | null => {
  try {
    const raw = sessionStorage.getItem(STORAGE_KEY);
    if (!raw) return null;
    return JSON.parse(raw);
  } catch {
    return null;
  }
};

export const clearPlpFilterState = (): void => {
  try {
    sessionStorage.removeItem(STORAGE_KEY);
  } catch {
    // silently ignore storage errors
  }
};
